import { render } from "./ListaOrdini.vue?vue&type=template&id=6232bbec&ts=true"
import script from "./ListaOrdini.vue?vue&type=script&lang=ts"
export * from "./ListaOrdini.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__